import "~/styles.css";
import "~/antd.less";

import "./generic/polyfills";

import { createHashHistory } from "history";
import { enableMapSet } from "immer";
import React from "react";
import { createRoot } from "react-dom/client";

import { AnalyticsProvider } from "~/tools/analytics/provider";

import { createReduxStore } from "./app/state/ReduxStore";
import { MaintenanceBoundary } from "./components/maintenance-boundary";
import { DEFAULT_QUERY_CLIENT_CONFIG, QueryClient, QueryClientProvider } from "./queries/react-query";
import { Root } from "./Root";

enableMapSet();

// biome-ignore lint/style/noRestrictedGlobals: legacy
(window as { startTime?: number }).startTime = performance.now();

const queryClient = new QueryClient(DEFAULT_QUERY_CLIENT_CONFIG);

const history = createHashHistory();

const store = createReduxStore({ queryClient, history });

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
	<QueryClientProvider client={queryClient}>
		<AnalyticsProvider>
			<MaintenanceBoundary>
				<Root history={history} store={store} />
			</MaintenanceBoundary>
		</AnalyticsProvider>
	</QueryClientProvider>,
);
